import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  Grid,
  Box,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { createTrafficAnalysisStarUrl } from "Redux/starSlice";
import { toggleVisibility, changeModeType, changeTime, ModeType } from "Redux/passageSlice";
import { useState } from "react";
import TimePicker2 from "Components/TimePicker2";

export default function Passage() {
  const dispatch = useAppDispatch();

  const { visible, mode, time } = useAppSelector((state) => state.passage);
  const [fakeTime, setFakeTime] = useState({ to: "16:00:00", from: "15:00:00" });

  const label = { inputProps: { "aria-label": "Switch demo" } };

  // const handleLastState = () => {
  //   const theDate = new Date();
  //   if (!predict) {
  //     if (lastState) {
  //       dispatch(
  //         changeTime({
  //           from: "",
  //           to: "",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         changeTime({
  //           from: `${theDate.getHours() - 1}:${theDate.getMinutes()}:${theDate.getSeconds()}`,
  //           to: `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`,
  //         })
  //       );
  //     }
  //     dispatch(toggleLastState());
  //   }
  // };

  // const handlePredict = () => {
  //   const theDate = new Date();
  //   if (!lastState) {
  //     if (predict) {
  //       dispatch(
  //         changeTime({
  //           from: "",
  //           to: "",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         changeTime({
  //           from: `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`,
  //           to: `${theDate.getHours() + 1}:${theDate.getMinutes()}:${theDate.getSeconds()}`,
  //         })
  //       );
  //     }
  //     dispatch(togglePredict());
  //   }
  // };

  const handleRangeTime = (name: string, t: string) => {
    console.log(name, t, "gbefbnhgy");
    dispatch(changeTime({ ...time, [name]: t }));
  };

  const handleSwitch = () => {
    dispatch(toggleVisibility());

    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=5196acca-de07-49ae-b520-d9e3da6e095b`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=951c3a23-75b4-45bb-9061-63873399b71b`,
      ])
    );
  };

  const handleChangeType = (event: React.MouseEvent<HTMLElement>, newMode: ModeType) => {
    if (newMode !== null) {
      dispatch(changeModeType(newMode));
      if (newMode === "last") {
        dispatch(changeTime({ from: "15:00:00", to: "16:00:00" }));
      }
      if (newMode === "now") {
        const theDate = new Date();
        const hour = theDate.getHours();
        const minutes = theDate.getMinutes();
        const seconds = theDate.getSeconds();
        const nowDate = Date.now();
        const fakeMili = nowDate - 15 * 60 * 1000;
        const theFakeDate = new Date(fakeMili);
        const fakeHour = theFakeDate.getHours();
        const fakeMinutes = theFakeDate.getMinutes();
        const fakeSeconds = theFakeDate.getSeconds();

        setFakeTime({ from: `${fakeHour}:${fakeMinutes}:${fakeSeconds}`, to: `${hour}:${minutes}:${seconds}` });
        dispatch(changeTime({ from: `${hour - 1}:${minutes}:${seconds}`, to: `${hour}:${minutes}:${seconds}` }));
      }
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" style={{ alignItems: "center" }}>
        <Grid container spacing={1} sx={{ width: "550px" }}>
          <Grid item xs={12} md={5.5}>
            <ToggleButtonGroup value={mode} exclusive onChange={handleChangeType} aria-label="time-mode">
              <ToggleButton
                value="last"
                aria-label="last"
                style={{
                  width: "76px",
                  height: "56px",
                  backgroundColor: mode === "last" ? "#4754CA" : "",
                  color: mode === "last" ? "#fff" : "",
                }}
              >
                گذشته
              </ToggleButton>
              <ToggleButton
                value="now"
                aria-label="now"
                style={{
                  width: "76px",
                  height: "56px",
                  backgroundColor: mode === "now" ? "#4754CA" : "",
                  color: mode === "now" ? "#fff" : "",
                }}
              >
                حال
              </ToggleButton>
              <ToggleButton
                value="predict"
                aria-label="predict"
                style={{
                  width: "76px",
                  height: "56px",
                  backgroundColor: mode === "predict" ? "#4754CA" : "",
                  color: mode === "predict" ? "#fff" : "",
                }}
              >
                آینده
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={12} md={3}>
            <TimePicker2
              label="از ساعت"
              setData={(v) => handleRangeTime("from", v)}
              name="from"
              data={mode === "now" ? fakeTime : time}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TimePicker2
              label=" تا ساعت"
              setData={(v) => handleRangeTime("to", v)}
              name="to"
              data={mode === "now" ? fakeTime : time}
            />
          </Grid>
        </Grid>
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
